<template>
  <div
    :class="[
      'widget-step wallet-step',
      { 'active': isActiveStep }
    ]"
    data-test-id="fill-wallet-address"
  >
    <StepTitle
      :stepNumber="stepNumber"
      @click.native="$emit('setStep', stepNumber)"
    >
      {{ i18n.wallet_step_title() }}
    </StepTitle>
    <AccordeonWrapper v-if="isActiveStep">
      <div class="widget-step__inner">
        <input-field
          class="field__wallet"
          data-test-id="fill-wallet-address-input"
          v-model.trim="walletAddress"
          :autocomplete="false"
          label=""
          :name="selectedAssetWithoutSpace"
          :id="selectedAssetWithoutSpace"
          :autofocus="true"
          v-validate="`required|${addressRuleFor(selectedAssetWithoutSpace)}`"
          :errorMessage="errors.first(selectedAssetWithoutSpace)"
        />
        <span
          class="validation-error"
          data-test-id="fill-wallet-address-input-error"
        >
          {{ validationErrors }}
        </span>

        <div class="btn-container">
          <md-button
            type="button"
            :disabled="false"
            class="btn md-mint"
            data-test-id="fill-wallet-address-btn"
            @click="onClickHandler"
          >
            {{ i18n.withdraw_withdraw() }}
          </md-button>
        </div>
      </div>
    </AccordeonWrapper>
  </div>
</template>

<script>
  import { i18n } from '@js/i18n'
  import { addressRuleFor } from '@utils/consts'
  import formMixin from '@com/mixins/form.mixin'

  import StepTitle from '@com/UI/StepTitle.vue'
  import AccordeonWrapper from '@com/UI/AccordeonWrapper.vue'
  import InputField from '@com/fields/InputField'

  export default {
    name: 'fill-wallet-address',
    mixins: [formMixin],
    components: {
      StepTitle,
      AccordeonWrapper,
      InputField
    },
    props: {
      stepNumber: {
        type: [Number, String],
        required: true
      },
      isActiveStep: {
        type: Boolean,
        default: false
      },
      selectedAssetWithoutSpace: {
        type: String,
        default: ''
      }
    },
    emits: ['setStep', 'setWalletAddress'],
    data () {
      return {
        i18n,
        walletAddress: ''
      }
    },
    computed: {
      validationErrors () {
        const requiredRule = this.errors.items.find(item => item.rule === 'required')
        if (requiredRule) return requiredRule.msg.replace(/USDT[A-Z]+\d+/, '')

        return this.errors.first(this.selectedAssetWithoutSpace)
          ? this.errors.first(this.selectedAssetWithoutSpace)
          : ''
      }
    },
    methods: {
      addressRuleFor,
      async onClickHandler () {
        const validationResult = await this.isValid()
        if (!validationResult) return

        this.$emit('setWalletAddress', this.walletAddress)
      }
    }
  }
</script>

<style lang="scss">
.wallet-step {
  .btn-container {
    display: flex;
    margin-top: 37px;

    .btn {
      min-width: 100%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/app/dashboard/widgets/WithdrawalWidget/FillWalletAddress.vue